import Navbar from "./components/navbar";
import CookiesPopup from "./components/cookies-popup";
import LazyLoadImages from "./components/lazyLoadImages";
import SliderTrusted from "./components/SliderTrusted";
import Modal from "./components/modal";

let lazy = null;

function gtag_report_conversion(url) {
  var callback = function () {
    if (typeof url != "undefined") {
      window.location = url;
    }
  };
  gtag("event", "conversion", {
    send_to: "AW-998066631/aZ-hCP6Jh9MYEMeT9dsD",
    event_callback: callback,
  });
  return false;
}

window.addEventListener("DOMContentLoaded", (event) => {
  setTimeout(() => {
    lazy = new LazyLoadImages();
    window.lazy = lazy;

    new Navbar("#header", ".navbar-burger", "#nav").mount();
    new CookiesPopup().mount();

    document.querySelector(".slider-trusted-us") &&
      new SliderTrusted().init(lazy);

    const modals = Array.from(document.querySelectorAll(".modal"));
    modals &&
      modals.forEach((modal) => {
        Modal().init(modal);
      });
  }, 1);

  window.loadScript = (src, handle, resolver) => {
    return new Promise((resolve, reject) => {
      if (!document.querySelector(`script[src="${src}"]`)) {
        const script = document.createElement("script");
        script.src = src;
        script.id = handle;

        const parent = document.querySelector("#" + resolver);

        try {
          document.body.insertBefore(script, parent);
        } catch (err) {
          console.log(err, parent, script);
          reject(err);
        }

        const event = new Event("loaded-" + handle);
        document.dispatchEvent(event);

        parent.remove();
        resolve();
      } else {
        resolve();
      }
    });
  };

  document.addEventListener(
    "wpcf7mailsent",
    function (event) {
      gtag_report_conversion();
    },
    false
  );

  const phoneCTA = document.querySelector(".phone-cta");

  if (phoneCTA) {
    phoneCTA.addEventListener("click", (e) => {
      console.log("dziala");
      gtag("config", "AW-998066631/1cjSCJ-Eg9MYEMeT9dsD", {
        phone_conversion_number: "608816943",
      });
    });
  }
});

window.addEventListener("resize", () => {
  lazy.update();
});

window.addEventListener("scroll", (e) => {
  const footerPhone = document.querySelector(".mobile-phone-wrapper");
  if (window.scrollY > 144 && window.innerWidth < 991) {
    footerPhone.classList.add("scrolled-down");
  } else {
    footerPhone.classList.remove("scrolled-down");
  }
});
